import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const AdvisorActionsCell = (props: {
  advisorId: string;
  advisoryOrganizationId: string;
  firstName: string;
  lastName: string;
  loginId: null | string;
  onDelete: () => void;
  onEdit: () => void;
}) => {
  const navigate = useNavigate();
  const [isDeleteOpen, toggleDeleteOpen] = useToggle();

  const onViewLogin = () => {
    if (!props.loginId) return;

    navigate({ params: { loginId: props.loginId }, to: '/users/$loginId' });
  };

  const onConfirmDelete = () => {
    toggleDeleteOpen();
    props.onDelete();
  };

  return (
    <>
      <ActionMenu
        actions={[
          { content: 'Delete', onSelect: toggleDeleteOpen },
          { content: 'Edit', onSelect: props.onEdit },
          {
            content: 'Impersonate',
            onSelect: () => {
              window.open(
                `/api/v3/admin/advisory-organizations/${props.advisoryOrganizationId}/advisors/${props.advisorId}/impersonate`,
                '_blank'
              );
            }
          },
          {
            content: 'View Login',
            disabled: !props.loginId,
            onSelect: onViewLogin,
            tooltip: props.loginId ? undefined : 'No login is linked'
          }
        ]}
        trigger={
          <IconButton
            data-testid={camelCase(
              `actions ${props.firstName} ${props.lastName}`
            )}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Delete'
        data-testid={camelCase(`delete ${props.firstName} ${props.lastName}`)}
        isOpen={isDeleteOpen}
        message={`Are you sure you want to delete advisor ${props.firstName} ${props.lastName}?`}
        onCancel={toggleDeleteOpen}
        onConfirm={onConfirmDelete}
        title='Delete Advisor'
      />
    </>
  );
};
